import { render } from "./EditProductGroupModal.vue?vue&type=template&id=0d54fc58"
import script from "./EditProductGroupModal.vue?vue&type=script&lang=js"
export * from "./EditProductGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__